module.exports = __webpack_public_path__ + "static/media/cross.1d14b247.svg";